import axiosInstance from './axiosInstance'

export type ExtraFieldType = 'string' | 'int' | 'bool'

export interface ExtraFieldItem {
  key: string
  type: ExtraFieldType
  value: string | number | boolean
}

export type ExtraFieldsMap = Record<string, string | number | boolean>

export interface SkyMobiConfigItem {
  id: string
  package_name: string
  app_version: string
  app_version_number?: string
  ads_open: boolean
  ads_delay: number
  ads_day: number
  ads_level: number
  ads_sky_appid: string
  ads_sky_siteid: string
  url: string
  extraFields: ExtraFieldsMap
  createdAt?: string
  updatedAt?: string
}

export interface SkyMobiConfigPayload {
  package_name: string
  app_version: string
  ads_open: boolean
  ads_delay: number
  ads_day: number
  ads_level: number
  ads_sky_appid: string
  ads_sky_siteid: string
  url: string
  extraFields: ExtraFieldsMap
}

export class SkyMobiConfigApi {
  static async getList(params?: { package_name?: string }): Promise<SkyMobiConfigItem[]> {
    const response = await axiosInstance.get('/cms/v1/sky-mobi-config', { params })
    return response.data.data.list || []
  }

  static async getById(id: string): Promise<SkyMobiConfigItem> {
    const response = await axiosInstance.get(`/cms/v1/sky-mobi-config/${id}`)
    return response.data.data.item
  }

  static async create(data: SkyMobiConfigPayload): Promise<SkyMobiConfigItem> {
    const response = await axiosInstance.post('/cms/v1/sky-mobi-config', data)
    return response.data.data.item
  }

  static async update(id: string, data: SkyMobiConfigPayload): Promise<SkyMobiConfigItem> {
    const response = await axiosInstance.put(`/cms/v1/sky-mobi-config/${id}`, data)
    return response.data.data.item
  }

  static async delete(id: string): Promise<void> {
    await axiosInstance.delete(`/cms/v1/sky-mobi-config/${id}`)
  }
}
